function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Template = require('./main.template');
var BugsMain = /*#__PURE__*/function () {
  function BugsMain(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#saito-container';
    _classCallCheck(this, BugsMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.state = {
      bugs: [],
      loading: true,
      error: '',
      filters: {
        view: 'active',
        status: '',
        severity: '',
        priority: '',
        assignee_publickey: '',
        reporter_publickey: '',
        search: '',
        sort: 'weight'
      }
    };
    app.connection.on('bugs-updated', function () {
      if (_this.isActiveRoute()) return _this.refreshCurrentView();
    });
    app.connection.on('bugs-candidate-discovered', function () {
      if (_this.isActiveRoute() && !_this.detailId()) return _this.render();
    });
  }
  return _createClass(BugsMain, [{
    key: "isActiveRoute",
    value: function isActiveRoute() {
      return typeof window !== 'undefined' && /^\/bugs(?:\/|$)/.test(window.location.pathname);
    }
  }, {
    key: "detailId",
    value: function detailId() {
      if (typeof window === 'undefined') return '';
      var match = window.location.pathname.match(/^\/bugs\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var detailId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              detailId = this.detailId();
              if (!detailId) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.renderDetail(detailId));
            case 1:
              this.replace(Template.list(this.state, this.mod));
              this.restoreFilters();
              this.attachListEvents();
              if (!this.state.loading) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return this.refresh();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "replace",
    value: function replace(html) {
      if (document.querySelector(this.container)) {
        this.app.browser.replaceElementContentBySelector(html, this.container);
      } else {
        this.app.browser.addElementToDom("<div id=\"saito-container\" class=\"saito-container\">".concat(html, "</div>"));
      }
    }
  }, {
    key: "restoreFilters",
    value: function restoreFilters() {
      var form = document.querySelector('.bugs-filters');
      if (!form) return;
      for (var _i = 0, _Object$entries = Object.entries(this.state.filters); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          name = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (form.elements[name]) form.elements[name].value = value;
      }
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.state.loading = true;
              this.state.error = '';
              this.replace(Template.list(this.state, this.mod));
              this.restoreFilters();
              this.attachListEvents();
              _context2.p = 1;
              _context2.n = 2;
              return this.mod.loadBugs(this.state.filters);
            case 2:
              this.state.bugs = _context2.v;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.state.error = _t.message || String(_t);
            case 4:
              this.state.loading = false;
              this.replace(Template.list(this.state, this.mod));
              this.restoreFilters();
              this.attachListEvents();
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }()
  }, {
    key: "refreshCurrentView",
    value: function () {
      var _refreshCurrentView = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var id;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              id = this.detailId();
              return _context3.a(2, id ? this.renderDetail(id) : this.refresh());
          }
        }, _callee3, this);
      }));
      function refreshCurrentView() {
        return _refreshCurrentView.apply(this, arguments);
      }
      return refreshCurrentView;
    }()
  }, {
    key: "attachListEvents",
    value: function attachListEvents() {
      var _document$querySelect,
        _this2 = this;
      (_document$querySelect = document.querySelector('.bugs-create')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', function () {
        return _this2.mod.editor.open('create');
      });
      var viewToggles = _toConsumableArray(document.querySelectorAll('.bugs-view-input'));
      var _iterator = _createForOfIteratorHelper(viewToggles),
        _step;
      try {
        var _loop = function _loop() {
          var viewToggle = _step.value;
          viewToggle.onchange = function () {
            var active = document.querySelector('[data-view="active"]');
            var completed = document.querySelector('[data-view="completed"]');
            if (!active.checked && !completed.checked) {
              viewToggle.checked = true;
              return;
            }
            _this2.state.filters.view = active.checked && completed.checked ? 'all' : completed.checked ? 'completed' : 'active';
            _this2.refresh();
          };
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var filters = document.querySelector('.bugs-filters');
      if (filters) {
        filters.onchange = function () {
          return _this2.readFilters(filters);
        };
        filters.onsubmit = function (event) {
          event.preventDefault();
          _this2.readFilters(filters);
        };
        var timer;
        filters.elements.search.oninput = function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            return _this2.readFilters(filters);
          }, 250);
        };
      }
      document.querySelectorAll('.bug-row').forEach(function (element) {
        var _element$querySelecto, _element$querySelecto2, _element$querySelecto3;
        var id = element.dataset.id;
        element.querySelector('.bug-row-open').onclick = function () {
          return _this2.navigate("/bugs/".concat(id));
        };
        (_element$querySelecto = element.querySelector('.bug-row-up')) === null || _element$querySelecto === void 0 || _element$querySelecto.addEventListener('click', function () {
          return _this2.move(id, -1);
        });
        (_element$querySelecto2 = element.querySelector('.bug-row-down')) === null || _element$querySelecto2 === void 0 || _element$querySelecto2.addEventListener('click', function () {
          return _this2.move(id, 1);
        });
        (_element$querySelecto3 = element.querySelector('.bug-row-edit')) === null || _element$querySelecto3 === void 0 || _element$querySelecto3.addEventListener('click', function () {
          var bug = _this2.state.bugs.find(function (candidate) {
            return candidate.root_tx_sig === id;
          });
          if (bug) _this2.mod.editor.open('edit', bug);
        });
        element.ondragstart = function (event) {
          return event.dataTransfer.setData('text/plain', id);
        };
        element.ondragover = function (event) {
          return event.preventDefault();
        };
        element.ondrop = function (event) {
          event.preventDefault();
          _this2.mod.moveBug(event.dataTransfer.getData('text/plain'), id, _this2.state.bugs.map(function (bug) {
            return bug.root_tx_sig;
          }));
        };
      });
      document.querySelectorAll('.bugs-candidate-capture').forEach(function (button) {
        button.onclick = function () {
          var candidate = _this2.mod.discoveredCandidates.get(button.dataset.id);
          if (candidate) _this2.mod.editor.open('capture', candidate);
        };
      });
    }
  }, {
    key: "readFilters",
    value: function readFilters(form) {
      var data = Object.fromEntries(new FormData(form).entries());
      Object.assign(this.state.filters, data);
      this.refresh();
    }
  }, {
    key: "move",
    value: function move(id, direction) {
      var index = this.state.bugs.findIndex(function (bug) {
        return bug.root_tx_sig === id;
      });
      var target = this.state.bugs[index + direction];
      if (target) this.mod.moveBug(id, target.root_tx_sig, this.state.bugs.map(function (bug) {
        return bug.root_tx_sig;
      }));
    }
  }, {
    key: "navigate",
    value: function navigate(path) {
      window.history.pushState({}, '', path);
      this.render();
    }
  }, {
    key: "renderDetail",
    value: function () {
      var _renderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id) {
        var bug, host, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              bug = this.mod.clientBugs.get(id);
              if (bug) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.mod.loadBug(id);
            case 1:
              bug = _context4.v;
            case 2:
              if (bug) {
                _context4.n = 3;
                break;
              }
              this.replace('<main class="bugs-main"><div class="bugs-state" role="alert">Bug not found.</div></main>');
              return _context4.a(2);
            case 3:
              this.replace(Template.detail(bug, this.mod));
              this.attachDetailEvents(bug);
              _context4.p = 4;
              _context4.n = 5;
              return this.mod.redsquare.renderThread('.bug-thread', {
                root_tx_sig: bug.root_tx_sig,
                source_tx_sig: bug.source_tx_sig,
                reply: true
              });
            case 5:
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t2 = _context4.v;
              host = document.querySelector('.bug-thread');
              if (host) host.innerHTML = "<div class=\"bugs-state\" role=\"alert\">".concat(this.app.browser.escapeHTML(_t2.message), "</div>");
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[4, 6]]);
      }));
      function renderDetail(_x) {
        return _renderDetail.apply(this, arguments);
      }
      return renderDetail;
    }()
  }, {
    key: "attachDetailEvents",
    value: function attachDetailEvents(bug) {
      var _this3 = this,
        _document$querySelect2,
        _document$querySelect3;
      document.querySelector('.bug-detail-back').onclick = function () {
        return _this3.navigate('/bugs');
      };
      document.querySelector('.bug-detail-open-redsquare').onclick = function () {
        return _this3.openInRedSquare(bug)["catch"](function (err) {
          return _this3.mod.showError(err);
        });
      };
      (_document$querySelect2 = document.querySelector('.bug-detail-edit')) === null || _document$querySelect2 === void 0 || _document$querySelect2.addEventListener('click', function () {
        return _this3.mod.editor.open('edit', bug);
      });
      (_document$querySelect3 = document.querySelector('.bug-detail-delete')) === null || _document$querySelect3 === void 0 || _document$querySelect3.addEventListener('click', function () {
        return _this3.mod.handleWorkflowAction(bug, 'untrack');
      });
      document.querySelector('.bug-detail-reply').onclick = function () {
        return _this3.mod.replyToBug(bug)["catch"](function (err) {
          return _this3.mod.showError(err);
        });
      };
      var metadataControls = [['.bug-detail-status', 'set-status'], ['.bug-detail-severity', 'set-severity'], ['.bug-detail-priority', 'set-priority']];
      var _loop2 = function _loop2() {
        var _metadataControls$_i = _slicedToArray(_metadataControls[_i2], 2),
          selector = _metadataControls$_i[0],
          action = _metadataControls$_i[1];
        var control = document.querySelector(selector);
        if (control) {
          control.onchange = function () {
            return _this3.mod.handleWorkflowAction(bug, action, control.value);
          };
        }
      };
      for (var _i2 = 0, _metadataControls = metadataControls; _i2 < _metadataControls.length; _i2++) {
        _loop2();
      }
    }
  }, {
    key: "openInRedSquare",
    value: function () {
      var _openInRedSquare = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(bug) {
        var bugsView;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              bugsView = document.querySelector('.bugs-main');
              _context5.n = 1;
              return this.mod.redsquare.openThread(bug.root_tx_sig, bug.source_tx_sig);
            case 1:
              // RedSquare may use Saito's soft navigation even though it is not the
              // active module. If that leaves the Bugs DOM mounted, complete the route
              // transition with a normal page load.
              if (bugsView !== null && bugsView !== void 0 && bugsView.isConnected && !window.location.pathname.startsWith('/bugs')) {
                window.location.reload();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function openInRedSquare(_x2) {
        return _openInRedSquare.apply(this, arguments);
      }
      return openInRedSquare;
    }()
  }]);
}();
module.exports = BugsMain;